import { Injectable } from '@angular/core';
import {GeneralServicesImplService} from '../../../../services/general-services-impl.service';
import {HttpClient} from '@angular/common/http';
import * as servers from '../../../../services/api/servers';
import {urls} from '../../../../services/api/urls';
import {Observable} from 'rxjs';
import {ProjectConstants} from '../../../project-constants';

@Injectable({
  providedIn: 'root'
})

export class MonthlyChargesUploadService extends GeneralServicesImplService {
  constructor(http: HttpClient) {
    super(http);
  }

  // baseUrl: string = servers.apiUrl + urls.cobidbService + urls.consuntivoChargesController;
  baseUrl: string = servers.apiUrl + urls.consuntivoChargesController;

  uploadMonthlyCharges(file: FormData, numAnnoMese: number, providerCod: string, status: string): Observable<any> {
    const url = this.baseUrl
                + this.LINKS.UPLOAD_CONSUMPTIVE_CHARGES
                + '/' + numAnnoMese.toString()
                + '/' + providerCod
                + '/' + status;
    const body =  file;
    return this.http.post( url, body, {headers: ProjectConstants.returnHeaderBlank(), responseType: 'json'})
      .pipe(
        // map (data => data) da inserire gestione errori
      );
  }

}
